// extracted by mini-css-extract-plugin
export default {"picker":"country-picker_picker__7aS9Z","select":"country-picker_select__OXv5L"};